import CreateUpdateBeneficiary from './CreateUpdate';
export default CreateUpdateBeneficiary;
